// extracted by mini-css-extract-plugin
export default {"pageTop":"Footer_pageTop__BoZ5v","breadcrumbs":"Footer_breadcrumbs__qLaIz"};